import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconFileTypography } from "@tabler/icons-react";
import { LuFileType } from "react-icons/lu";

export default function TypeFilter({
  selected,
  setSelected,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  const data = [
    { key: "Character", value: "Character" },
    { key: "Event", value: "Event" },
    { key: "Leader", value: "Leader" },
    { key: "Stage", value: "Stage" },
  ];
  return (
    <GenericFilter
      classNames="w-28"
      selected={selected}
      startContent={<IconFileTypography />}
      setSelected={setSelected}
      selectionMode="single"
      label="Type"
      data={data}
    />
  );
}
